import { useEffect, useState } from "react";
import SupervisorDashboardFilters from "../dashboardfilters/superadmindashboardfilters";
import SuperVisorSearch from "../dashboardfilters/supervisorsearch";
import SuperVisorTable from "../tables/weektable";
import SuperAdminTable from "../tables/superadmintable";
import api from "../api/api";
import dayjs from "dayjs";

const OperationDashboard=()=>{
    const [filterby,setFilterBy]=useState('No Grouping')
const [tableloading,setTableLoading]=useState(false)
const [tableData,setTableData]=useState([])
    const [selectedDateRange, setSelectedDateRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: "selection"
    });
     const [isDateRangeOpen, setIsDateRangeOpen] = useState(false);
const fetchtable=async()=>{
    try {
        setTableLoading(true)
        const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
        const formattedStartDate = selectedDateRange?.startDate 
            ? new Date(selectedDateRange.startDate).toISOString().split('T')[0] 
            : today;
        const formattedEndDate = selectedDateRange?.endDate 
            ? new Date(selectedDateRange.endDate).toISOString().split('T')[0] 
            : today;
        const response = await api.get("/v1/timesheets", {
          params: {
             start_date:formattedStartDate, // Updated format
             end_date: formattedEndDate, // Updated format
            supervisor_id: "1234567890",
          },
        });
          if(response.status===200){

            setTableData(response?.data||[])
          }else{
            setTableData([])
          }
          
    } catch (error) {
        console.log(error)
    }finally{
        setTableLoading(false)

    }
}
useEffect(()=>{

fetchtable()
},[selectedDateRange])

    return(<>
         <div className="sm:pt-7 sm:px-8 mb-12">
         <SupervisorDashboardFilters filterby={filterby} 
         isDateRangeOpen={isDateRangeOpen} setIsDateRangeOpen={setIsDateRangeOpen}
         setFilterBy={setFilterBy} selectedDateRange={selectedDateRange} setSelectedDateRange={setSelectedDateRange}
         fetchtable={fetchtable}
         />
         <div className="mb-2">
      <SuperVisorSearch />   
      </div>
   
      <SuperAdminTable filterby={filterby} tableData={tableData} tableloading={tableloading} />

         </div>
    
    </>)
}
export default OperationDashboard;